import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx, Schema, TagGroup } from "../schema"
import type { CreateValue } from "../types"
import type { DeleteID, UpdateValue } from "@rocicorp/zero"
import { tagMutators } from "./tags"

export const tagGroupMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateValue<TagGroup>
			ctx: ZeroJwtPayload
		}) => {
			await tx.mutate.tagGroups.insert({
				id: args.id,
				name: args.name,
				color: args.color,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				version: 1,
				workspaceId: authData.workspaceId,
			})
		},
	),
	update: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: UpdateValue<Schema["tables"]["tagGroups"]>
		}) => {
			await tx.mutate.tagGroups.update({
				id: args.id,
				name: args.name,
				color: args.color,
			})
		},
	),
	delete: defineMutator(
		async ({
			tx,
			args,
			ctx,
		}: {
			tx: MutatorTx
			args: DeleteID<Schema["tables"]["tagGroups"]>
			ctx: ZeroJwtPayload
		}) => {
			// Get all tags in this group
			const tags = await tx.query.tags.where("tagGroupId", args.id).run()

			// Delete all tags in the group, reusing the tag delete recipe
			await Promise.all(
				tags.map(async (tag) =>
					tagMutators.delete.fn({ tx, args: { id: tag.id }, ctx }),
				),
			)

			await tx.mutate.tagGroups.update({
				id: args.id,
				isDeleted: true,
			})
		},
	),
}
